import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './NotFoundPage.module.scss';
import clsx from 'clsx';
import NotFound from '../../components/NotFound/NotFound';
import Button from '../../components/Button/Button';
import { useNavigate } from 'react-router';
const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={clsx(styles.wrap)}>
        <NotFound
          title="Страница не найдена"
          text="Проверьте ссылку или перейдите на главную"
          button={
            <Button
              type="success"
              className={clsx(styles.btnClose)}
              onClick={() => {
                navigate('/');
              }}>
              На главную
            </Button>
          }
        />
      </div>
    </>
  );
};

export default NotFoundPage;
